import React from 'react';

interface CareXLogoProps {
  style?: React.CSSProperties;
  className?: string;
  /** Height of the logo. Defaults to auto (fills container). */
  height?: string | number;
  /** Width of the logo. Defaults to auto (maintains aspect ratio). */
  width?: string | number;
}

const CareXLogo: React.FC<CareXLogoProps> = ({
  style,
  className,
  height,
  width,
}) => (
  <img
    src={process.env.PUBLIC_URL + '/assets/carex-logo1.png'}
    alt="CareX Nursing Home Software"
    style={{
      height: height ?? 'auto',
      width: width ?? 'auto',
      maxWidth: '100%',
      objectFit: 'contain',
      display: 'block',
      ...style,
    }}
    className={className}
  />
);

export default CareXLogo;